import { useState } from 'react';
import { ApiError } from '../../lib/api';
import { apiEspace } from '../../lib/espace';

interface Props {
  /** Appelé avec l'espace créé, dont le compte est propriétaire. */
  onCree: (espace: { id: string; name: string }) => void;
  onAnnuler?: () => void;
}

/**
 * Ouvrir un espace de plus (29/10/2026). Un espace = un payeur = une série de
 * factures : c'est ainsi qu'on facture une autre société séparément. L'espace
 * naît vide ; on y crée ensuite le dossier de cette société.
 */
export function CreerEspace({ onCree, onAnnuler }: Props) {
  const [nom, setNom] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [envoi, setEnvoi] = useState(false);

  const creer = async () => {
    if (!nom.trim()) {
      setErreur('Donnez un nom à cet espace (le nom de la société, par exemple).');
      return;
    }
    setEnvoi(true);
    setErreur(null);
    try {
      onCree(await apiEspace.creerEspace(nom.trim()));
    } catch (e) {
      setErreur(e instanceof ApiError ? e.message : 'L’espace n’a pas pu être créé.');
      setEnvoi(false);
    }
  };

  return (
    <div className="dos-recap" role="group" aria-labelledby="creer-espace">
      <p id="creer-espace">
        <strong>Nouvel espace</strong> — il aura sa propre société facturée, ses membres et ses abonnements.
      </p>
      <div className="dos-question">
        <label htmlFor="creer-espace-nom">Nom de l’espace</label>
        <input id="creer-espace-nom" value={nom} maxLength={150} onChange={(e) => setNom(e.target.value)} />
      </div>
      {erreur ? (
        <p className="dos-erreur" role="alert">
          {erreur}
        </p>
      ) : null}
      <div className="dos-actions">
        {onAnnuler ? (
          <button type="button" className="btn btn-secondaire" onClick={onAnnuler}>
            Annuler
          </button>
        ) : null}
        <button type="button" className="btn" disabled={envoi} onClick={() => void creer()}>
          {envoi ? 'Création…' : 'Créer l’espace'}
        </button>
      </div>
    </div>
  );
}
